import { BillingDates, ExpirationDates } from '@trello/product-features';

/**
 * Check if a paid account is about to expire. Can be determined
 * when the expirationDates object on the paidAccount contains
 * a key that matches the product code
 *
 * @deprecated
 */
export function willExpire(paidAccount?: {
  products: number[];
  expirationDates: ExpirationDates;
}) {
  return (
    paidAccount?.products &&
    paidAccount?.products?.[0] in (paidAccount?.expirationDates ?? {})
  );
}

/**
 * Get the next billing date for a give paidAccount
 * object. Looks up the date string for the product
 * and converts it to a Date. Returns null if not
 * applicable
 */
export const getNextBillingDate = (paidAccount?: {
  products: number[];
  billingDates: BillingDates;
}): Date | null => {
  const product = paidAccount?.products?.[0];
  const billingDates = paidAccount?.billingDates;
  if (
    !product ||
    !billingDates ||
    !Object.prototype.hasOwnProperty.call(billingDates, product)
  ) {
    return null;
  }
  return new Date(billingDates[product]);
};

/**
 * Get the expiration date for a give paidAccount
 * object. Looks up the date string for the product
 * and converts it to a Date. Returns null if not
 * applicable
 */
export const getExpirationDate = (paidAccount?: {
  products: number[];
  expirationDates: ExpirationDates;
}): Date | null => {
  const product = paidAccount?.products?.[0];
  const expirationDates = paidAccount?.expirationDates;
  if (
    !product ||
    !expirationDates ||
    !Object.prototype.hasOwnProperty.call(expirationDates, product)
  ) {
    return null;
  }
  return new Date(expirationDates[product]);
};
